var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"padding flix-text-center flix-html-h2",class:_vm.getClass()},[_c('flixIcon',{attrs:{"id":_vm.$getStatusIcon({status: _vm.status})}}),_vm._v(" "+_vm._s(_vm.$t("message."+_vm.status))+": "+_vm._s(_vm.current)+" x ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }